// AppContent.js — kompletan funkcionalan deo iz App.js sa useConsent
import React from "react";
import {
  Routes,
  Route,
  Link,
  Navigate,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useConsent } from "./context/ConsentContext";
import useCoreTracking from "./analytics/useCoreTracking";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Upload from "./pages/Upload";
import Guide from "./pages/Guide";
import Viewer from "./pages/Viewer";
import Demo from "./pages/Demo";
import ViewerWrapper from "./pages/ViewerWrapper";
import Download from "./pages/Download";
import Pricing from "./pages/Pricing";
import UserProfile from "./pages/UserProfile";
import CookiesPolicy from "./pages/CookiesPolicy";
import Footer from "./components/Footer";
import Login from "./Login";
import SEO from "./components/SEO";
import BlogList from "./pages/blog/BlogList";
import BlogPost from "./pages/blog/BlogPost";
import ProjectDefinition from "./pages/ProjectDefinition"; // ako fajl staviš u pages/
import { useNavigate } from "react-router-dom";
import SubjectManager from "./pages/SubjectManager"; // ← lokacija tvoje stranice
import TechnologyManager from "./components/TechnologyManager";
import SubjectTechnologyManager from "./components/SubjectTechnologyManager";
import MachineList from "./components/MachineList";
import MachineEdit from "./components/MachineEdit";
import ProjectDocsPage from "./pages/ProjectDocsPage";
import ProjectOverview from "./pages/ProjectOverview";
import ProjectOffer from "./pages/ProjectOffer";
import ProjectDocs from "./pages/ProjectDocs";
import QrLocationForm from "./pages/QrLocationForm";
import MeasureApp from "./pages/MeasureApp";
import Ocr from "./pages/Ocr";
import CrmMainPage from "./pages/crm/CrmMainPage"; // <- putanja do tvoje nove strane
import KitchensLandingSR from "./pages/KitchensLandingSR";
import ScrollToTop from "./components/ScrollToTop";
import RequireAuth from "./components/RequireAuth";
import ProductsManagement from "./components/ProductsManagement";
import InteriorScanLanding from "./pages/InteriorScanLanding";
import CatalogBrowser from "./components/CatalogBrowser";
import Projects from "./pages/marketing/Projects";
import ProjectDetails from "./pages/marketing/ProjectDetails";
import LoginPage from "./pages/LoginPage";
import ProjectsAdmin from "./pages/marketing/admin/ProjectsAdmin";
import ProjectEdit from "./pages/marketing/admin/ProjectEdit";
import BiDashboard from "./pages/BiDashboard";
import OfferPage from "./pages/OfferPage";
import MailboxHome from "./pages/mail/MailboxHome";
import CrmSettingsPage from "./pages/crm/CrmSettingsPage";
import BankPage from "./pages/finance/BankPage";
import HRDashboard from "./pages/hr/HRDashboard";
import HRPeoplePage from "./pages/hr/HRPeoplePage";
import HRSettingsPage from "./pages/hr/HRSettingsPage";
import HROrgChartPage from "./pages/hr/HROrgChartPage";
import HRPositionsPage from "./pages/hr/HRPositionsPage";
import HRPersonProfile from "./pages/hr/HRPersonProfile";
import NotificationBell from "./components/notifications/NotificationBell";
import ITAdminPage from "./pages/it/ITAdminPage";
import ITAdminAccessPage from "./pages/it/ITAdminAccessPage";
import ITUserAccessDetailPage from "./pages/it/ITUserAccessDetailPage";
import ITRolePolicyMappingsPage from "./pages/it/ITRolePolicyMappingsPage";
import ITScopeRulesPage from "./pages/it/ITScopeRulesPage";
import ITPoliciesPage from "./pages/it/ITPoliciesPage";
import ITModulesPage from "./pages/it/ITModulesPage";
import ITMyAccessDebugPage from "./pages/it/ITMyAccessDebugPage";
import ITAuditPage from "./pages/it/ITAuditPage";
import RequireModuleAccess from "./components/auth/RequireModuleAccess";
import RequirePermission from "./components/auth/RequirePermission";
import ITPermissionsPage from "./pages/it/ITPermissionsPage";
import ITMailAccountsPage from "./pages/it/ITMailAccountsPage";
import ITMailAccountAccessPage from "./pages/it/ITMailAccountAccessPage";
import ITMailSignatureTemplatesPage from "./pages/it/ITMailSignatureTemplatesPage";
import ITMailSignatureProfilesPage from "./pages/it/ITMailSignatureProfilesPage";
import ITSignatureBrandingDefaultsPage from "./pages/it/ITSignatureBrandingDefaultsPage";
import ITNotificationsPage from "./pages/it/ITNotificationsPage";
import ITPositionRolesPage from "./pages/it/ITPositionRolesPage";
import ProjectDeliveryCheckPage from "./pages/projects/ProjectDeliveryCheckPage";
import QAQCDashboardPage from "./pages/qaqc/QAQCDashboardPage";
import ERPDashboardPage from "./modules/erp/pages/ERPDashboardPage";
import DocumentListPage from "./modules/erp/pages/DocumentListPage";
import DocumentEditorPage from "./modules/erp/pages/DocumentEditorPage";
import InventoryDashboardPage from "./modules/erp/pages/InventoryDashboardPage";
import ResourceItemsPage from "./modules/erp/pages/ResourceItemsPage";
import SupplierItemsPage from "./modules/erp/pages/SupplierItemsPage";
import SupplierItemPricesPage from "./modules/erp/pages/SupplierItemPricesPage";
import PurchaseOrdersPage from "./modules/erp/pages/PurchaseOrdersPage";
import PurchaseOrderEditorPage from "./modules/erp/pages/PurchaseOrderEditorPage";
import InteriorProjectsPage from "./modules/interior-editor/pages/InteriorProjectsPage";
import InteriorLibraryPage from "./modules/interior-editor/pages/InteriorLibraryPage";
import ModuleDefinitionHierarchyPage from "./modules/interior-editor/pages/ModuleDefinitionHierarchyPage";
import InteriorEditorPage from "./modules/interior-editor/pages/InteriorEditorPage";
import BoardDefinitionEditorPage from "./modules/interior-editor/pages/BoardDefinitionEditorPage";
import InteriorAssetsPage from "./modules/interior-editor/pages/InteriorAssetsPage";
import InteriorCatalogPage from "./modules/interior-editor/pages/InteriorCatalogPage";
import InteriorItemMountingEditorPage from "./modules/interior-editor/pages/InteriorItemMountingEditorPage";
import InteriorParameterRegistryPage from "./modules/interior-editor/pages/InteriorParameterRegistryPage";
import InteriorCategoryManagerPage from "./modules/interior-editor/pages/InteriorCategoryManagerPage";
import InteriorMaterialLibraryPage from "./modules/interior-editor/pages/InteriorMaterialLibraryPage";
import InteriorMaterialEditorPage from "./modules/interior-editor/pages/InteriorMaterialEditorPage";
import InteriorItemAssemblyEditorPage from "./modules/interior-editor/pages/InteriorItemAssemblyEditorPage";
import InteriorAssetMountingEditorPage from "./modules/interior-editor/pages/InteriorAssetMountingEditorPage";
import InteriorHardwareDefinitionSetupPage from "./modules/interior-editor/pages/InteriorHardwareDefinitionSetupPage";


const AppContent = ({ user, setUser, headerRef, headerHeight, isLoaded, theme, setTheme, leftMenuOpen, setLeftMenuOpen, rightMenuOpen, setRightMenuOpen }) => {
  const { t, i18n } = useTranslation();
 const { getConsent } = useConsent();
  const navigate = useNavigate();
  
  const consentState = getConsent();
  useCoreTracking({ consent: consentState, user });

  const PrivateRoute = ({ element }) => {
    return user ? element : <Navigate to="/" replace />;
  };

  return (
    <>
      <SEO title="Modular Platform" description="Modular Platform for 3D design and planning." />
      <header
        ref={headerRef}
        className="bg-primary-light dark:bg-primary-dark text-white dark:text-black shadow-md border-b relative z-50"
      >
        <div className="relative flex items-center h-16">
          <div className="hidden nav:flex items-center gap-4 absolute left-4">
            <nav className="flex gap-4 font-semibold text-white dark:text-black">
              <Link to="/" className="hover:underline">{t("home")}</Link>
              <Link to="/guide" className="hover:underline">{t("guide")}</Link>
              <Link to="/3d-scan" className="hover:underline"> {t("scanLanding.Title")} </Link>
              <Link to="/pricing" className="hover:underline">{t("pricing.pricing")}</Link>
              <Link to={`/${i18n.language}/blog`} className="hover:underline">{t("blog")}</Link>
              <Link to="/projects" className="hover:underline">{t("projects.heroTitle")}</Link>
              {user && <Link to="/katalog">Katalog</Link>}
              {user && <Link to="/dashboard" className="hover:underline">{t("dashboard")}</Link>}
              {user && <Link to="/upload" className="hover:underline">{t("upload")}</Link>}
            </nav>
          </div>

          <div className="absolute left-1/2 transform -translate-x-1/2">
            <Link to="/">
              <img src="https://modularobjects.com/svg/logo-white.svg" alt="Logo" className="h-10 block dark:hidden" />
              <img src="https://modularobjects.com/svg/logo-black.svg" alt="Logo" className="h-10 hidden dark:block" />
            </Link>
          </div>

          <div className="hidden nav:flex items-center gap-2 absolute right-4">


            <select
              className="btn-primary"
              onChange={(e) => i18n.changeLanguage(e.target.value)}
              defaultValue={i18n.language}
            >
              {["en", "de", "fr", "es", "it","ru", "zh", "hu", "cs", "nl", "pl", "pt", "ro", "sr"].map((lang) => (
                <option key={lang} value={lang}>{lang.toUpperCase()}</option>
              ))}
            </select>
            <button className="btn-primary" onClick={() => setTheme(theme === "light" ? "dark" : "light")}>
              {theme === "light" ? t("dark_mode") : t("light_mode")}
            </button>
            {user && (
              <Link to="/profile" className="btn-primary">{t("profile")}</Link>
            )}
            <span className="inline-flex items-center">
              <Login user={user} setUser={setUser} />
            </span>
            
{/* 🔔 NOTIFICATIONS */}
  {user && <NotificationBell />}
          </div>

          <button className="nav:hidden text-white dark:text-black text-2xl px-2 absolute left-2" onClick={() => setLeftMenuOpen(!leftMenuOpen)}>
            ☰
          </button>
         
          <button className="nav:hidden text-white dark:text-black text-3xl px-2 absolute right-16" onClick={() => setRightMenuOpen(!rightMenuOpen)}>
            ⚙
          </button>
           <div className="nav:hidden absolute right-2 flex items-center">
  {user && <NotificationBell />}
</div>
        </div>

        {leftMenuOpen && (
          <div className="nav:hidden mt-2 bg-white dark:bg-neutral-800 rounded shadow-md p-2 text-black dark:text-white flex flex-wrap gap-x-4">
            <Link to="/" onClick={() => setLeftMenuOpen(false)}>{t("home")}</Link>
            <Link to="/guide" onClick={() => setLeftMenuOpen(false)}>{t("guide")}</Link>
            <Link to="/pricing" onClick={() => setLeftMenuOpen(false)}>{t("pricing.pricing")}</Link>
            <Link to={`/${i18n.language}/blog`} onClick={() => setLeftMenuOpen(false)}>{t("blog")}</Link>
            <Link to="/3d-scan" onClick={() => setLeftMenuOpen(false)} > {t("scanLanding.Title")} </Link>
            <Link to="/projects" onClick={() => setLeftMenuOpen(false)}>Projects</Link>
            {user &&<Link to="/katalog">Katalog</Link>}
            {user && <Link to="/dashboard" onClick={() => setLeftMenuOpen(false)}>{t("dashboard")}</Link>}
            {user && <Link to="/upload" onClick={() => setLeftMenuOpen(false)}>{t("upload")}</Link>}
          </div>
        )}

        {rightMenuOpen && (
          <div className="nav:hidden mt-2 bg-white dark:bg-neutral-800 rounded shadow-md p-2 text-white dark:text-black">
            <div className="flex flex-wrap justify-end items-center gap-2 w-full">
              
              <select
                className="px-2 py-1 rounded bg-primary-light text-white dark:text-black text-sm font-semibold hover:opacity-90 transition"
                onChange={(e) => i18n.changeLanguage(e.target.value)}
                defaultValue={i18n.language}
              >
                {["en", "de", "fr", "es", "it","ru", "zh", "hu", "cs", "nl", "pl", "pt", "ro", "sr"].map((lang) => (
                  <option key={lang} value={lang}>{lang.toUpperCase()}</option>
                ))}
              </select>
              <button
                onClick={() => setTheme(theme === "light" ? "dark" : "light")}
                className="px-2 py-1 rounded bg-primary-light text-white dark:text-black text-sm font-semibold hover:opacity-90 transition"
              >
                {theme === "light" ? t("dark_mode") : t("light_mode")}
              </button>
              {user && (
                <Link
                  to="/profile"
                  onClick={() => setRightMenuOpen(false)}
                  className="px-2 py-1 rounded bg-primary-light text-white dark:text-black text-sm font-semibold hover:opacity-90 transition"
                >
                  {t("profile")}
                </Link>
              )}
              <div className="inline-flex items-center">
                <Login user={user} setUser={setUser} />
              </div>
            </div>
          </div>
        )}
      </header>

      <div className="flex flex-col min-h-screen">
        <main className="flex-1 bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark">
          <ScrollToTop smooth /> {/* ili bez smooth ako želiš instant */}
          <Routes>
            <Route path="/" element={<Home user={user} />} />
            <Route path="/dashboard" element={<PrivateRoute element={<Dashboard isLoaded={isLoaded} />} />} />
            <Route path="/demo" element={<Demo isLoaded={isLoaded} />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/viewer" element={<Viewer headerHeight={headerHeight} />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/demo3d/:modelCode" element={<ViewerWrapper headerHeight={headerHeight} />} />
            <Route path="/download" element={<Download />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/cookies-policy" element={<CookiesPolicy />} />
            <Route path="/:lang/blog" element={<BlogList />} />
            <Route path="/:lang/blog/:slug" element={<BlogPost />} />
            <Route path="/subjects" element={<SubjectManager />} />
            <Route path="/technologies" element={<TechnologyManager />} />
            <Route path="/subject-technologies" element={<SubjectTechnologyManager />} />
            <Route path="/machines" element={<PrivateRoute element={<MachineList />} />} />
            <Route path="/machines/new" element={<PrivateRoute element={<MachineEdit />} />} />
            <Route path="/machines/:id/edit" element={<MachineEdit />} />
            <Route path="/machines/:id" element={<MachineEdit />} />
            <Route path="/project/:projectId/docs" element={<ProjectDocsPage />} />
            <Route path="/project/:projectId/overview" element={<PrivateRoute element={<ProjectOverview />} />} />
            <Route path="/project/:projectId/offer" element={<ProjectOffer />} />
            <Route path="/project/:projectId/docs" element={<ProjectDocs />} />
            <Route path="/project/:projectId" element={<ProjectOverview />} />
            <Route path="/project/:projectId/order" element={<ProjectDefinition />} />
            <Route path="/qrlocation" element={<QrLocationForm />} />
            <Route path="/measure" element={<MeasureApp />} />
            <Route path="/ocr" element={<Ocr />} />
            <Route path="/crm" element={<RequireAuth><RequireModuleAccess moduleCode="crm"><CrmMainPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/kuhinje" element={<KitchensLandingSR />} />
            <Route path="/products" element={<RequireAuth><RequireModuleAccess moduleCode="products"><ProductsManagement /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/3d-scan" element={<InteriorScanLanding />} />
            <Route path="/katalog" element={<CatalogBrowser />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:slug" element={<ProjectDetails />} />
            <Route path="/login" element={<LoginPage user={user} setUser={setUser} />} />
            <Route path="/marketing/admin/projects" element={<RequireAuth><RequireModuleAccess moduleCode="dashboard"><ProjectsAdmin /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/marketing/admin/projects/:id" element={<RequireAuth><RequireModuleAccess moduleCode="dashboard"><ProjectEdit /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/bi" element={<RequireAuth><RequireModuleAccess moduleCode="dashboard"><BiDashboard /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/offer/:code" element={<OfferPage />} />
            <Route path="/mailbox" element={<RequireAuth><RequireModuleAccess moduleCode="mail"><MailboxHome /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/crm/settings" element={<CrmSettingsPage />} />
            <Route path="/finance/bank" element={<RequireAuth><RequireModuleAccess moduleCode="bank"><BankPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/hr" element={<RequireAuth><RequireModuleAccess moduleCode="hr"><HRDashboard /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/hr/people" element={<RequireAuth><RequirePermission permission="hr.people.read"><HRPeoplePage /></RequirePermission></RequireAuth>}/>
            <Route path="/hr/people" element={<RequireAuth><RequirePermission permission="hr.people.read"><HRPeoplePage /></RequirePermission></RequireAuth>}/>
            <Route path="/hr/settings" element={<RequireAuth><RequirePermission permission="hr.structure.write"><HRSettingsPage /></RequirePermission></RequireAuth>}/>
            <Route path="/hr/org-chart" element={<HROrgChartPage />} />
            <Route path="/hr/positions" element={<HRPositionsPage />} />
            <Route path="/hr/people/:id" element={<HRPersonProfile />} />
            <Route path="/it" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITAdminPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/access/users" element={<ITAdminAccessPage />} />
            <Route path="/it/access/users/:id" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITUserAccessDetailPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/hr-role-mappings" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITRolePolicyMappingsPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/scope-rules" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITScopeRulesPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/policies" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITPoliciesPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/modules" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITModulesPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/access-preview" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITMyAccessDebugPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/audit" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITAuditPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/permissions" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITPermissionsPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/mail/accounts" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITMailAccountsPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/mail/accounts/:id" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITMailAccountAccessPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/mail/signature-templates" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITMailSignatureTemplatesPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/mail/signature-profiles" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITMailSignatureProfilesPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/mail/signature-branding-defaults" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITSignatureBrandingDefaultsPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/notifications" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITNotificationsPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/it/position-roles" element={<RequireAuth><RequireModuleAccess moduleCode="it"><ITPositionRolesPage /></RequireModuleAccess></RequireAuth>}/>
            <Route path="/projects/qa-qc/:projectKey" element={<ProjectDeliveryCheckPage />} />
            <Route path="/qaqc" element={<QAQCDashboardPage />} />
            <Route path="/erp" element={<ERPDashboardPage />} />
            <Route path="/erp/documents" element={<DocumentListPage />} />
            <Route path="/erp/documents/:id" element={<DocumentEditorPage />} />
            <Route path="/erp/inventory" element={<InventoryDashboardPage />} />
            <Route path="/erp/resource-items" element={<ResourceItemsPage />} />
            <Route path="/erp/supplier-items" element={<SupplierItemsPage />} />
            <Route path="/erp/supplier-items/:id/prices" element={<SupplierItemPricesPage />} />
            <Route path="/erp/purchase-orders" element={<PurchaseOrdersPage />} />
            <Route path="/erp/purchase-orders/new" element={<PurchaseOrderEditorPage />} />
            <Route path="/erp/purchase-orders/:id" element={<PurchaseOrderEditorPage />} />
            <Route path="/interior-editor" element={<InteriorProjectsPage />} />
            <Route path="/interior-editor/projects" element={<InteriorProjectsPage />} />
            <Route path="/interior-editor/projects/:projectId" element={<InteriorEditorPage />} />
            <Route path="/interior-editor/library" element={<InteriorLibraryPage />} />
            <Route path="/interior-editor/library/modules/:definitionId/hierarchy" element={<ModuleDefinitionHierarchyPage />}/>
            <Route path="/interior-editor/library" element={<InteriorLibraryPage />} />
            <Route path="/interior-editor/projects" element={<InteriorProjectsPage />} />
            <Route path="/interior-editor/projects/:projectId" element={<InteriorEditorPage />}/>
            <Route path="/interior-editor/definitions/:definitionId/hierarchy" element={<ModuleDefinitionHierarchyPage />}/>
            <Route path="/interior-editor/definitions/:definitionId/board" element={<BoardDefinitionEditorPage />}/>
            <Route path="/interior-editor/assets" element={<InteriorAssetsPage />} />
            <Route path="/interior-editor/catalog" element={<InteriorCatalogPage />} />
            <Route path="/interior-editor/catalog/items/:itemId/mounting" element={<InteriorItemMountingEditorPage />}/>
            <Route path="/interior-editor/catalog/items/:itemId/assembly" element={<InteriorItemAssemblyEditorPage />}/>
            <Route path="/interior-editor/parameters" element={<InteriorParameterRegistryPage />}/>
            <Route path="/interior-editor/categories" element={<InteriorCategoryManagerPage />}/>
            <Route path="/interior-editor/materials" element={<InteriorMaterialLibraryPage />}/>
            <Route path="/interior-editor/materials/:id" element={<InteriorMaterialEditorPage />}/>
            <Route path="/interior-editor/assets/:assetId/mounting" element={<InteriorAssetMountingEditorPage />}/>
            <Route path="/interior-editor/hardware-definitions/:definitionId/setup" element={<InteriorHardwareDefinitionSetupPage />}/>
          </Routes>
        </main>
<CookieBanner /> {/* 👈 Dodato ovde */}
        <Footer />
      </div>
    </>
  );
};

export default AppContent;
